import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { MAX_PASSWORD_LENGTH_CHARACTERS, ONE_SPECIAL_CHARACTER, PASSWORD_REQUIREMENTS } from 'swag-common/constants/validations';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import classes from './password-requirements-block.scss';
const animationClasses = {
  enter: classes.enter,
  enterActive: classes.enterActive,
  enterDone: classes.enterDone,
  exit: classes.exit,
  exitActive: classes.exitActive
};
const animationSwitchClasses = {
  enter: classes.enterSwitch,
  enterActive: classes.enterActiveSwitch,
  enterDone: classes.enterDoneSwitch,
  exit: classes.exitSwitch,
  exitActive: classes.exitActiveSwitch
};
const SPECIAL_PASSWORD_CHARACTERS = '!“#$%&‘()*+,-./:;<=>?@[]^_`{|}~';
const isPasswordRequirementDone = (idx, requirements) => {
  return Number.isInteger(requirements === null || requirements === void 0 ? void 0 : requirements.find(doneIdx => doneIdx === idx));
};
const getRequirementsList = ({
  isLengthMoreThanMaxAllowedCharacters,
  completedRequirements,
  isMobileView,
  className
}) => {
  const firstColumnArr = PASSWORD_REQUIREMENTS.slice(0, 3);
  const secondColumnArr = PASSWORD_REQUIREMENTS.slice(3, 6);
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(classes.requirementsList, className, isMobileView && classes.requirementsListMobile)
  }, isMobileView ? /*#__PURE__*/React.createElement("div", {
    className: classes.requirementsBlock
  }, PASSWORD_REQUIREMENTS.map((requirement, index) => {
    if (requirement === ONE_SPECIAL_CHARACTER) {
      return /*#__PURE__*/React.createElement("li", {
        key: requirement,
        className: classNames(classes.requirement, classes.requirementWithTooltip, isPasswordRequirementDone(index, completedRequirements) && classes.doneRequirement)
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.rule
      }, requirement), /*#__PURE__*/React.createElement(Tooltip, {
        title: SPECIAL_PASSWORD_CHARACTERS,
        placement: "top"
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.tooltipInfo
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        classes: {
          root: classes.infoIcon
        }
      }))));
    }
    return /*#__PURE__*/React.createElement("li", {
      key: requirement,
      className: classNames(classes.requirement, isPasswordRequirementDone(index, completedRequirements) && classes.doneRequirement)
    }, requirement);
  }), /*#__PURE__*/React.createElement("li", {
    key: MAX_PASSWORD_LENGTH_CHARACTERS,
    className: classNames(classes.requirement, classes.maxCharactersRequirement, isLengthMoreThanMaxAllowedCharacters && classes.maxCharactersRequirementAppear)
  }, MAX_PASSWORD_LENGTH_CHARACTERS)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.requirementsBlock
  }, firstColumnArr.map((requirement, index) => /*#__PURE__*/React.createElement("li", {
    key: requirement,
    className: classNames(classes.requirement, isPasswordRequirementDone(index, completedRequirements) && classes.doneRequirement)
  }, requirement))), /*#__PURE__*/React.createElement("div", {
    className: classes.requirementsBlock
  }, secondColumnArr.map((requirement, index) => {
    if (requirement === ONE_SPECIAL_CHARACTER) {
      return /*#__PURE__*/React.createElement("li", {
        key: requirement,
        className: classNames(classes.requirement, classes.requirementWithTooltip, isPasswordRequirementDone(index + 3, completedRequirements) && classes.doneRequirement)
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.rule
      }, requirement), /*#__PURE__*/React.createElement(Tooltip, {
        title: SPECIAL_PASSWORD_CHARACTERS,
        placement: "top"
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.tooltipInfo
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        classes: {
          root: classes.infoIcon
        }
      }))));
    }
    return /*#__PURE__*/React.createElement("li", {
      key: requirement,
      className: classNames(classes.requirement, isPasswordRequirementDone(index + 3, completedRequirements) && classes.doneRequirement)
    }, requirement);
  }), /*#__PURE__*/React.createElement("li", {
    key: MAX_PASSWORD_LENGTH_CHARACTERS,
    className: classNames(classes.requirement, classes.maxCharactersRequirement, isLengthMoreThanMaxAllowedCharacters && classes.maxCharactersRequirementAppear)
  }, MAX_PASSWORD_LENGTH_CHARACTERS))));
};
const PasswordRequirementsBlock = ({
  isLengthMoreThanMaxAllowedCharacters,
  className,
  completedRequirements,
  isAllRequirementsCompleted,
  isInputFocused
}) => {
  const isMobileView = isMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isInputFocused || isAllRequirementsCompleted,
    classNames: animationClasses,
    timeout: 450,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    key: isAllRequirementsCompleted ? '1' : '2',
    timeout: 150,
    classNames: animationSwitchClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !isAllRequirementsCompleted ? getRequirementsList({
    completedRequirements,
    isMobileView,
    isLengthMoreThanMaxAllowedCharacters,
    className
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.passwordSecure
  }, "Your password is secure, you're all set!"))))));
};
export default PasswordRequirementsBlock;